import { useTranslation } from 'react-i18next';
import isElectron from 'is-electron';
import { SPage, STitle, SDescription, SLoginLink } from './Login.styles';
import { translate } from '../../utils/translate';
import { useAppSelector } from '../../hooks';
import { selectSessionExchangeErrorStatus } from './LoginSlice';
import { Banner } from '../../components/Banner';
import { buildLoginWebUrl } from '../../utils/loginWeb';

export const Login = () => {
  const { t } = useTranslation();
  const sessionExchangeErrorStatus = useAppSelector(selectSessionExchangeErrorStatus);

  const loginWebUrl = buildLoginWebUrl();

  return (
    <SPage>
      <div style={{ flex: 3 }} />
      <STitle>{translate('login_ulf_title')}</STitle>
      <SDescription>{translate('login_ulf_description')}</SDescription>
      {!isElectron() && (
        <SLoginLink aria-label="Log in" href={loginWebUrl}>
          {t('login_ulf_button')}
        </SLoginLink>
      )}
      {isElectron() && (
        <SLoginLink
          aria-label="Log in"
          as="button"
          onClick={() => window.electronApi?.sendLoginOpen(loginWebUrl)}
        >
          {t('login_ulf_button')}
        </SLoginLink>
      )}
      {sessionExchangeErrorStatus && <Banner description={t('login_error')} />}
      <div style={{ flex: 5 }} />
    </SPage>
  );
};
